import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'normaliseAcl'
})
export class NormaliseAclPipe implements PipeTransform {

  constructor(private t:TranslateService){}

  transform(value: any, ...args: any[]): Observable<string> {

    if ( value ) {
      return this.t.get('GENERIC.ACL.' + value.toUpperCase())
      //let string = value.replace(/_/g, ' ');
      //return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return of(value);
    }
  }

}
